import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../globalStyles';
import { ScoreDelta } from './ScoreDelta';
import { RadarChart } from './RadarChart';
import { formatDisplayValue } from '../utils';

type IndexPanelProps = {
  circular?: boolean;
  color: string;
  delta?: number | null;
  fill: string;
  labels: string[];
  score: number;
  title: string;
  values: number[];
};

export const IndexPanel = ({
  circular,
  color,
  delta,
  fill,
  labels,
  score,
  title,
  values,
}: IndexPanelProps) => (
  <IndexPanelDiv>
    <IndexInfoDiv>
      <IndexLabel>{title}</IndexLabel>
      <IndexScoreDiv>
        {formatDisplayValue(score)}
        <span> / 100</span>
      </IndexScoreDiv>
      <ScoreDelta delta={delta} />
    </IndexInfoDiv>
    <ChartFrameDiv>
      <RadarChart circular={circular} color={color} fill={fill} labels={labels} values={values} />
    </ChartFrameDiv>
  </IndexPanelDiv>
);

const IndexPanelDiv = styled.section`
  min-width: 0;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: ${colors.white};
  border: 1px solid ${colors.secondaryBorder};
  border-radius: 12px;
`;

const IndexInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

const IndexLabel = styled.h2`
  margin: 0;
  color: ${colors.text};
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const IndexScoreDiv = styled.div`
  color: ${colors.text};
  font-size: 46px;
  font-weight: 700;
  line-height: 1;

  span {
    color: ${colors.grayText};
    font-size: 22px;
    font-weight: 400;
  }
`;

const ChartFrameDiv = styled.div`
  width: 100%;
  height: 360px;
`;
